<template>
  <div v-if="isUserAdmin()">

    <div class="text-2xl">
      User Feedback
    </div>

    <UserFeedbackList />
  </div>
</template>

<script>
  import UserFeedbackList from "./UserFeedbackList"
  import { EventBus }     from '@/shared/event-bus';

  export default {
    components: {
      UserFeedbackList,
    },
  }
</script>
